import React, { useMemo } from 'react';
import { OpenCampaignCardContent, OpenCampaignCardPlusContent } from '@lux/campaign-card';
import { Translate } from '@pegasus/translation';
import { useConfig } from '@browsing/config';
import * as S from './styles';
export var CampaignCardContent = function (_a) {
    var discount = _a.discount, endsAt = _a.endsAt, isEarlyAccess = _a.isEarlyAccess, isExclusive = _a.isExclusive;
    var config = useConfig();
    var isSpecial = discount === null || discount === void 0 ? void 0 : discount.isSpecial;
    var isOmnibusRRPEnabled = config.isEnabled('omnibusRRP');
    var finalDiscount = useMemo(function () {
        if (isSpecial) {
            return React.createElement(Translate, { message: "campaigns.campaignSpecial", raw: true });
        }
        if (discount === null || discount === void 0 ? void 0 : discount.maxDiscount) {
            if (isOmnibusRRPEnabled) {
                return (React.createElement(S.RRPRegularText, null,
                    React.createElement(Translate, { message: "campaigns.omniBusComplaince", params: { discount: "".concat(discount.maxDiscount) }, raw: true, html: true })));
            }
            return "".concat(discount.maxDiscount, "%");
        }
        return null;
    }, [discount === null || discount === void 0 ? void 0 : discount.maxDiscount, isOmnibusRRPEnabled, isSpecial]);
    var ContentComponent = isEarlyAccess || isExclusive ? OpenCampaignCardPlusContent : OpenCampaignCardContent;
    return (React.createElement(ContentComponent, { discount: finalDiscount, discountTitle: React.createElement("span", { style: { textTransform: 'lowercase' } },
            React.createElement(Translate, { message: "campaigns.upTo", raw: true })), endsAt: endsAt, endsAtTitle: React.createElement(Translate, { message: "timeLeft.endsIn", raw: true }), withSpecialDiscount: isSpecial, withOmnibusDiscount: isOmnibusRRPEnabled }));
};
